module.exports = __webpack_public_path__ + "d664201f/img/share-action-icon.9c12578c.svg";